module.exports = __webpack_public_path__ + "static/background-dac796cb6cb6e44db89db3ad102be1cd.png";